import { SectionShell } from "@/components/design-system/SectionShell";
import { Accordion, AccordionGroup, AccordionItem } from "@/components/ui/accordion";

const code = `import { Accordion, AccordionGroup, AccordionItem } from "@/components/ui/accordion";

<Accordion>
  <AccordionGroup title="Ordering & Minimums">
    <AccordionItem question="What is the minimum order?">
      <p>Every order is built from a 100-bottle mixable minimum...</p>
    </AccordionItem>
  </AccordionGroup>
</Accordion>`;

export function AccordionSection() {
  return (
    <SectionShell
      id="accordion"
      title="Accordion"
      description={
        <>
          Built on native <code>&lt;details&gt;/&lt;summary&gt;</code> rather than a Radix
          primitive, styled to the Private Cellar mockup's hairline/serif look. Each item is
          independently expandable, with no JavaScript state required.{" "}
          <code>AccordionGroup</code> renders a small gold group label above a set of items — used
          to cluster FAQ questions by topic.
        </>
      }
      whenToUse={
        <ul>
          <li>Grouped Q&amp;A on the public site (the FAQs page).</li>
          <li>Any long list of expand/collapse content where only one answer is read at a time.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            A single confirmation prompt or focused task — use the <code>Modal</code> primitive
            instead.
          </li>
          <li>Admin/signed-in screens that need Radix-level keyboard composition (roving focus, single-open groups).</li>
        </ul>
      }
      preview={
        <div className="bg-page p-6">
          <Accordion>
            <AccordionGroup title="Ordering & Minimums">
              <AccordionItem question="What is the minimum order?" defaultOpen>
                <p>
                  Every order is built from a 100-bottle mixable minimum — for example 50 red and
                  50 white, or any combination across our range.
                </p>
              </AccordionItem>
              <AccordionItem question="How do quotes work?">
                <p>
                  We provide a per-bottle price and a written quote once we know your wines,
                  quantities and label design.
                </p>
              </AccordionItem>
            </AccordionGroup>
          </Accordion>
        </div>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li>
            <code>AccordionItem</code> props: <code>question</code> (required),{" "}
            <code>defaultOpen</code> (optional, default closed).
          </li>
          <li>
            <code>AccordionGroup</code> props: <code>title</code> (required) — renders as an
            <code>&lt;h2&gt;</code> with the group label treatment.
          </li>
        </ul>
      }
    />
  );
}
